import TableBody from "@mui/material/TableBody";
import { withStyles } from "@mui/styles";

const StyledTableBody = withStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "",
  },
}))(TableBody);
export { StyledTableBody };